import { Component, OnInit } from '@angular/core';
import { ApiService } from "../../api.service";

@Component({
  selector: 'app-negar',
  templateUrl: './negar.page.html',
  styleUrls: ['./negar.page.scss'],
})
export class NegarPage implements OnInit {

  constructor(
    public api:ApiService
  ) { }

  ngOnInit() {
  }

}
